import React from 'react';
import { Outlet } from 'react-router-dom';

const UserManagement = () => (
  <Outlet />
);

export default UserManagement;
